import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.2624 2.70366C10.5856 2.38059 11.0239 2.19913 11.4809 2.19922C11.9379 2.1993 12.3761 2.38092 12.6992 2.70411C13.0223 3.0273 13.2037 3.4656 13.2036 3.92258C13.2035 4.37956 13.0219 4.81779 12.6987 5.14086L12.039 5.79966L9.60093 3.36426L10.2615 2.70366H10.2624ZM8.96643 4.00056L3.60603 9.35916C3.44332 9.52199 3.3207 9.72041 3.24783 9.93876L2.42523 12.4075C2.39895 12.4867 2.39522 12.5716 2.41446 12.6529C2.43369 12.7341 2.47513 12.8083 2.53415 12.8673C2.59316 12.9264 2.66743 12.9678 2.74864 12.987C2.82985 13.0063 2.91482 13.0025 2.99403 12.9763L5.46273 12.1537C5.68143 12.0817 5.87943 11.9584 6.04233 11.7955L11.4027 6.43686L8.96553 4.00056H8.96643Z",
  fill: "#56AF40"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };